import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var a = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-588 -848)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "black"
    }),
    /* @__PURE__ */ t("path", {
      d: "M6.31652 7.7876L6.82969 9.36697H8.49043L7.14684 10.3432L7.66008 11.9226L6.31652 10.9465L4.97293 11.9226L5.48617 10.3432L4.14258 9.36697H5.80332L6.31652 7.7876Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ t("path", {
      d: "M13.6837 7.7876L14.1969 9.36697H15.8576L14.514 10.3432L15.0273 11.9226L13.6837 10.9465L12.3401 11.9226L12.8534 10.3432L11.5098 9.36697H13.1705L13.6837 7.7876Z",
      fill: "#6DA544"
    })
  ]
});
export {
  a as default
};
